import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto5() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.47 39.76" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path
						class="cls-1"
						d="M52.3,31.73h-.93V3.54A3.43,3.43,0,0,0,48,.12H5.51A3.44,3.44,0,0,0,2.09,3.54V31.73H1.17a1,1,0,0,0-1,1.05v2.37a4.49,4.49,0,0,0,4.49,4.48H48.86a4.49,4.49,0,0,0,4.48-4.48V32.78A1,1,0,0,0,52.3,31.73ZM4.18,3.54A1.34,1.34,0,0,1,5.51,2.21H48a1.34,1.34,0,0,1,1.33,1.33V31.73H4.18ZM51.26,35.15a2.41,2.41,0,0,1-2.4,2.4H4.61a2.41,2.41,0,0,1-2.4-2.4V33.82H20.76v.31a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2v-.31H51.26Z"
					/>
					<path
						class="cls-1"
						d="M18.67,17.91l1.45.48v4.95a1,1,0,0,0,1,1H32.38a1,1,0,0,0,1-1V18.4l1.46-.48a1,1,0,0,0,.3-1.67l-2.55-2.07V11.62a1,1,0,1,0-1.94,0v1L27.25,9.86a1,1,0,0,0-1.23,0l-7.66,6.35a1,1,0,0,0-.12,1.37,1.06,1.06,0,0,0,.43.29Zm8-6,5.81,4.73-.43.14a1,1,0,0,0-.66.92v4.68H22.06V17.69a1,1,0,0,0-.66-.92l-.48-.14Z"
					/>
				</g>
			</g>
		</svg>
	);
}
